// Login landing — abre AuthModal automaticamente, igual que en leyro.es.

import { useState } from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';

import AuthModal from '../components/auth/AuthModal';
import { useAuthContext } from '../context/AuthContext';

export default function LoginPage(): JSX.Element {
  const { accessToken } = useAuthContext();
  const [params] = useSearchParams();
  const [open, setOpen] = useState(true);
  const next = params.get('next') ?? '/marketplace';

  if (accessToken) {
    return <Navigate to={next} replace />;
  }

  return (
    <main className="min-h-[60vh] flex items-center justify-center px-6 py-12 bg-subtle">
      <AuthModal open={open} onClose={() => setOpen(false)} initialMode="login" />
      {!open ? (
        <button type="button" onClick={() => setOpen(true)} className="btn-primary">
          Iniciar sesión
        </button>
      ) : null}
    </main>
  );
}
